import SocialFeedbackItem, {
  SocialFeedbackItemProps,
} from '@/components/elements/SocialFeedbackItem';
import {
  Box,
  chakra,
  Flex,
  Heading,
  useBreakpointValue,
  VStack,
} from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import React from 'react';
import Marquee from 'react-fast-marquee';

const CMarquee = chakra(Marquee);

export type SocialFeedbackProps = {
  feedbacks: SocialFeedbackItemProps[];
};

const SocialFeedback = ({ feedbacks }: SocialFeedbackProps) => {
  const { t } = useTranslation(`landing`);
  const isMobile = useBreakpointValue([true, true, false]);
  if (typeof window === `undefined`) {
    return <> </>;
  }
  return (
    <Flex
      whiteSpace="pre-line"
      as="section"
      justify="center"
      align="center"
      direction="column"
    >
      <Heading mb="20" as="h2" size="2xl" textAlign="center">
        {t(`social_feedback.header`)}
      </Heading>
      {isMobile ? (
        <VStack
          w="full"
          className="boxed-container"
          display={[null, null, `none`]}
        >
          {[...feedbacks].slice(0, 2).map((item) => (
            <SocialFeedbackItem
              key={item.id}
              id={item.id}
              avatar={item.avatar}
              occupation={item.occupation}
              quote={item.quote}
              name={item.name}
            />
          ))}
        </VStack>
      ) : (
        <Box as={CMarquee} pauseOnHover gradient={false}>
          {feedbacks.map((item) => (
            <SocialFeedbackItem
              key={item.id}
              id={item.id}
              avatar={item.avatar}
              occupation={item.occupation}
              quote={item.quote}
              name={item.name}
            />
          ))}
        </Box>
      )}
    </Flex>
  );
};

export default SocialFeedback;
